export default function StatusBadge({ status, small = false }) {
  const map = {
    AVAILABLE: { bg: '#e6f9f0', color: '#0a6640', label: 'AVAILABLE' },
    PENDING:   { bg: '#eef2ff', color: '#3b5bdb', label: 'PENDING' },
    SOLD:      { bg: '#f0f0f0', color: '#888',    label: 'SOLD' },
    AWAITING:  { bg: '#f0f0f0', color: '#888',    label: 'SOLD' },
    COMPLETED: { bg: '#f0f0f0', color: '#888',    label: 'SOLD' },
    PAID:      { bg: '#f0f0f0', color: '#888',    label: 'PAID' },
    FAILED:    { bg: '#ffe8e8', color: '#b42318', label: 'FAILED' },
    CANCELLED: { bg: '#ffe8e8', color: '#b42318', label: 'CANCELLED' },
  };
  const s = map[status] || map.AVAILABLE;

  return (
    <span style={{
      display: 'inline-block',
      padding: small ? '2px 7px' : '3px 9px',
      borderRadius: 3,
      background: s.bg,
      color: s.color,
      fontSize: small ? 9 : 10,
      fontWeight: 600,
      letterSpacing: '0.08em',
      fontFamily: 'DM Mono, monospace',
    }}>
      {s.label}
    </span>
  );
}
